import React, { useState } from "react"
import { EditUserFormTextField } from "./EditUserFormTextField"

interface User {
  id: number
  phone_number: string
}

interface PhoneNumberFieldProps {
  user: User
}

export const PhoneNumberField: React.FC<PhoneNumberFieldProps> = ({ user }) => {
  const [value, setValue] = useState(user.phone_number || "")

  const fieldData = {
    field: "phone_number",
    name: "phone_number",
    label: "Phone Number",
    placeholder: "Enter your phone number",
    required: false,
  }

  return (
    <>
      <EditUserFormTextField
        fieldData={fieldData}
        value={value}
        setValue={setValue}
        userId={user.id}
      />
    </>
  )
}
